import {getNextBaseMap} from "./getNextBaseMap";
import {styleIconsByName} from "./utils";
import * as React from "react";
import {useMemo} from "react";

interface Iprops {
    styleName: string;
}

export function BasemapImage (props: Iprops) {
    const imgUrl: string = useMemo(() =>
            styleIconsByName[getNextBaseMap(props.styleName)!],
[props.styleName]);

    if (imgUrl) {
        return <div><img alt={'Switch Basemap'} className="img-thumb" src={imgUrl}/></div>
    }

    return <span>Switch Basemap</span>;
}